import { render, staticRenderFns } from "./InviteJoinLose.vue?vue&type=template&id=4a106130"
import script from "./InviteJoinLose.vue?vue&type=script&lang=js"
export * from "./InviteJoinLose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports